"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.respondTo = void 0;
const breakpoints = {
  xs: {
    min: 0,
    max: 767
  },
  sm: {
    min: 768,
    max: 991
  },
  md: {
    min: 992,
    max: 1199
  },
  lg: {
    min: 1200,
    max: 9999999999
  }
};
var Device = /*#__PURE__*/function (Device) {
  Device["phone"] = "phone";
  Device["tablet"] = "tablet";
  Device["small_screen"] = "small_screen";
  Device["large_screen"] = "large_screen";
  return Device;
}(Device || {});
const respondTo = (device, content) => {
  function getQuery(device) {
    switch (device) {
      case Device.phone:
        return `@media only screen and (max-width: ${breakpoints.xs.max}px)`;
      case Device.tablet:
        return `@media only screen and (min-width: ${breakpoints.sm.min}px) and (max-width: ${breakpoints.sm.max}px)`;
      case Device.small_screen:
        return `@media only screen and (min-width: ${breakpoints.md.min}px) and (max-width: ${breakpoints.md.max}px)`;
      case Device.large_screen:
        return `@media only screen and (min-width: ${breakpoints.lg.min}px)`;
      default:
        return null;
    }
  }
  const mc = getQuery(device);
  return mc ? `${mc} { ${content} }` : '';
};
exports.respondTo = respondTo;